import { react, useState, useEffect, useRef } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import styles from './PickupWizard.module.css'; // Import css modules stylesheet as styles
import Stack from '@mui/material/Stack';
import AlertDialog from '../Modals/AlertDialog'
import IconButton from '@mui/material/IconButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import StyledCheckbox from '../StyledExtensions/StyledCheckbox'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import NotListedLocationIcon from '@mui/icons-material/NotListedLocation';
import StoreIcon from '@mui/icons-material/Store';
import SignpostIcon from '@mui/icons-material/Signpost';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';


export default function SpecialInstructions(props) {
    const [specialInstructions, setSpecialInstructions] = useState(props.pickupRequest.CustomerSpecialInstructions !== undefined ? props.pickupRequest.CustomerSpecialInstructions : '');
    return (
        <div style={{ maxWidth: '400px', marginLeft: 'auto', marginRight: 'auto' }}>
            <div className={styles.cardHeader}>Special Instructions</div>
            <div className={styles.cardQuestion} style={{ marginTop: '15px' }}>
                Please enter any special instructions for your Recycler such as:
            </div>

            <div>
                <div style={{ display: 'flex', marginTop: '20px', textAlign:'left' }}><NotListedLocationIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 50, marginRight:'10px'}} /> Where will the returnables will be located for a contactless pickup?</div>
                <div style={{ display: 'flex', marginTop: '20px', textAlign: 'right' }}>Does your request have many off brand returnables that can't be recycled at a major retail location? i.e. Meijer, Kroger, Walmart, etc.<StoreIcon sx={{ color: 'var(--sipzee-green)', fontSize: 50, alignSelf: 'center', marginLeft: '10px' }} /> </div>
                <div style={{ display: 'flex', marginTop: '20px', textAlign: 'left' }}><SignpostIcon sx={{ color: 'var(--sipzee-grey)', fontSize: 50, marginRight: '10px' }} /> Are there any special instructions required to find your house?</div>
                <div style={{ display: 'flex', marginTop: '20px', textAlign: 'right' }}>Do you live on a dirt road that may make access more difficult for a small vehicle?<DirectionsCarIcon sx={{ color: 'var(--sipzee-yellow-2)', fontSize: 50, marginLeft: '10px' }} /> </div>
                <div style={{ display: 'flex', marginTop: '20px', textAlign: 'left' }} ><FitnessCenterIcon style={{ alignSelf: 'center', marginRight: '10px' }} sx={{ color: 'var(--sipzee-green-2)', fontSize: 50 }} /> Are your bags/containers heavy? If you think any individual bag/container might weigh over 50lbs, please note it for our returners! These would typically be larger containers full of glass bottles.</div>
            </div>

            <div style={{ marginTop: '15px' }}>
                <TextField label="Special Instructions"
                    style={{minWidth:'300px'} }
                    onChange={(e) => setSpecialInstructions(e.target.value)}
                    value={specialInstructions}
                    variant="outlined"
                    multiline
                    rows={4}
                />
            </div>

            <div style={{ display: 'flex', marginTop: '15px', marginLeft:'10px', padding:'10px' }}>
                <NotificationImportantIcon className='pulseButton-red' sx={{ color: 'var(--sipzee-red)', fontSize: 50 }} />
                Note: Please ensure your cans & bottles are placed somewhere accessible to your Recycler for a contactless pickup.
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }} >
                <div style={{ display: 'flex', width: '300px', justifyContent: 'space-between' }}>
                    <Button variant="outlined" onClick={props.onBack} style={{ marginRight: '2px' }}><KeyboardArrowLeft /> Back</Button>
                    <Button variant="contained" color="sipzeeGreen" onClick={() => props.onNext(specialInstructions)}>Next <KeyboardArrowRight /></Button>
                </div>
            </div>
        </div>
    )
}